import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "../../tpsSideBar.css"


const SideNav = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [mastersOpen, setMastersOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const userName = localStorage.getItem('UserName');

  const handleResize = () => {
    setIsSidebarOpen(window.innerWidth >= 990);
  };
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('UserName');
    localStorage.removeItem('AuthorID');
    window.location.href = '/cl';
  };

  return (
    <>
      <button className="toggle-btn rounded h-2 w-2" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        ≡
      </button>

      <aside className={`off-canvas-menu ${isSidebarOpen ? 'open' : ''}`}>
        <div className="brand ml-2">TPS Author</div>
        <div className="user-panel border border-dark p-2 rounded">Welcome: {userName || 'Guest'}</div>

        <nav>
          <ul>
            <li><Link to="/author/dashboard">Dashboard</Link></li>
            <li>
              <button onClick={() => setMastersOpen(!mastersOpen)}>
                Masters {mastersOpen ? '▲' : '▼'}
              </button>
              {mastersOpen && (
                <ul>
                  <li><Link to="/author/papersubmit">Upload Submission</Link></li>
                  <li><Link to="/author/reviewer-decision">Reviewer Decisions</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => setReportsOpen(!reportsOpen)}>
                Reports {reportsOpen ? '▲' : '▼'}
              </button>
              {reportsOpen && (
                <ul>
                  <li><Link to="/author/paper-progress">Project Progress</Link></li>
                  <li><Link to="/author/all-papers">All Papers</Link></li>
                  <li><Link to="/author/accepted-papers">Accepted Papers</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </li>
          </ul>
        </nav>
      </aside>

      <div className={`overlay ${isSidebarOpen ? 'visible' : ''}`} onClick={() => setIsSidebarOpen(false)} />
    </>
  );
};

export default SideNav;
